import { RootState } from 'theSource/app/store';

export const selectHelpSearchString = (state: RootState) =>
  state?.enrollment?.homepage.helpSearchString;

export const selectLogoutButton = (state: RootState) =>
  state?.enrollment?.homepage.logout;
